<template>
  <div class="site-event-main" :style="hasNoContentAuth ? { height: '100%' } : {}">
    <div v-if="hasNoContentAuth" class="site-event-main-empty">
      <NoAuth />
    </div>
    <!-- 搜索排序 -->
    <div class="site-event-action" v-if="tabLists && tabLists.length > 0">
      <div class="site-event-action-content">
        <!-- tab -->
        <ul class="site-event-tab">
          <li
            v-for="tab in tabLists"
            :key="tab.key"
            :class="activeTabKey === tab.key ? 'active' : ''"
            @click="handleTabs(tab.key)"
          >
            {{ tab.name }}
          </li>
        </ul>

        <!-- 当前故障 -->
        <div class="site-event-action-row1" v-if="activeTabKey === '1'">
          <ul class="site-event-search">
            <li>
              <a-input
                :placeholder="$t('com_form_device_fault_placeholder')"
                v-model="deviceName"
                class="site-event-search-keyword"
                @pressEnter="getData"
                @change="
                  () => {
                    if (!deviceName) {
                      this.getData();
                    }
                  }
                "
                allowClear
              />
            </li>
            <!-- <li>
              <a-input :placeholder="$t('com_form_warning_name_placeholder')" v-model="alarmName" />
            </li> -->
            <li>
              <a-range-picker @change="dateRangeChange" v-model="date" />
            </li>
            <!-- Fault Code 暂时隐藏，因设备端没有这个值 -->
            <!-- <li>
            <a-input
              :placeholder="$t('com_form_fault_code_placeholder')"
              v-model="faultCode"
            />
          </li> -->
            <li>
              <a-button type="primary" @click="getData">
                {{ $t('com_btn_lookfor') }}
              </a-button>
              <a-button type="default" @click="handleReset">
                {{ $t('com_btn_reset') }}
              </a-button>
            </li>
          </ul>
          <!-- <div class="site-event-btn">
            <a-button type="link" @click="handleExpand()">
              <span v-if="!searchExpand">{{ $t('com_btn_expand') }}</span>
              <span v-else>{{ $t('com_btn_collapse') }}</span>
              <a-icon type="up" v-if="searchExpand" />
              <a-icon type="down" v-else />
            </a-button>
          </div> -->
        </div>

        <!-- 展开的搜索:当前故障 -->
        <div class="site-event-action-row2" v-if="searchExpand && activeTabKey === '1'">
          <span>{{ $t('com_alarm_type') }}</span>
          <!-- 0:OA,1:MA;2:CA -->
          <a-checkbox-group v-model="faultLevel" @change="getData">
            <a-checkbox value="0">
              OA
            </a-checkbox>
            <a-checkbox value="1">
              MA
            </a-checkbox>
            <a-checkbox value="2">
              CA
            </a-checkbox>
          </a-checkbox-group>
        </div>

        <!-- 历史故障 -->
        <div class="site-event-action-row1" v-if="activeTabKey === '2'">
          <ul class="site-event-search">
            <li>
              <a-input
                :placeholder="$t('com_form_device_fault_placeholder')"
                v-model="historyKeyword"
                class="site-event-search-keyword"
                @pressEnter="getData"
                @change="
                  () => {
                    if (!historyKeyword) {
                      this.getData();
                    }
                  }
                "
                allowClear
              />
            </li>
            <!-- <li>
              <a-input
                :placeholder="$t('com_form_warning_name_placeholder')"
                v-model="alarmNameHistory"
              />
            </li> -->
            <li>
              <a-range-picker @change="dateRangeChangeHistory" v-model="dateHistory" />
            </li>
            <!-- Fault Code 暂时隐藏，因设备端没有这个值 -->
            <!-- <li>
            <a-input
              :placeholder="$t('com_form_fault_code_placeholder')"
              v-model="faultCodeHistory"
            />
          </li> -->
            <li>
              <a-button type="primary" @click="getData">
                {{ $t('com_btn_lookfor') }}
              </a-button>
              <a-button type="default" @click="handleResetHistory">
                {{ $t('com_btn_reset') }}
              </a-button>
            </li>
          </ul>
          <!-- <div class="site-event-btn">
            <a-button type="link" @click="handleExpandHistory()">
              <span v-if="!searchExpandHistory">{{ $t('com_btn_expand') }}</span>
              <span v-else>{{ $t('com_btn_collapse') }}</span>
              <a-icon type="up" v-if="searchExpandHistory" />
              <a-icon type="down" v-else />
            </a-button>
          </div> -->
        </div>

        <!-- 展开的搜索:历史故障 -->
        <div class="site-event-action-row2" v-if="searchExpandHistory && activeTabKey === '2'">
          <span>{{ $t('com_alarm_type') }}</span>
          <!-- 0:OA,1:MA;2:CA -->
          <a-checkbox-group v-model="faultLevelHistory" @change="getData">
            <a-checkbox value="0">
              OA
            </a-checkbox>
            <a-checkbox value="1">
              MA
            </a-checkbox>
            <a-checkbox value="2">
              CA
            </a-checkbox>
          </a-checkbox-group>
        </div>
      </div>
    </div>

    <!-- 内容 -->
    <div class="site-event-content" v-if="tabLists && tabLists.length > 0">
      <!-- 站点编辑事件列表 -->
      <div v-if="activeTabKey === '1'" class="g-table">
        <a-table
          :columns="currentColumns"
          :data-source="currentDataList"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          :loading="currentLoading"
          @change="handleCurrentTable"
        >
          <!-- 设备名称 -->
          <template slot="devName" slot-scope="text, record">
            <router-link
              :to="{
                name: 'DeviceDetail',
                params: { id: record.devId },
              }"
              v-if="AUTH_DEVICE_DETAIL"
            >
              <span>{{ text }}</span>
            </router-link>
            <span v-else>
              {{ text }}
            </span>
          </template>

          <!-- 时间 -->
          <template slot="startTime" slot-scope="text">
            {{ text | formatDate('yyyy-MM-dd HH:mm:ss') }}
          </template>
        </a-table>
        <div class="pagination" style="margin-bottom:20px;">
          <Pagination
            :current.sync="currentPagination.current"
            :total="currentPagination.total"
            :pageSize.sync="currentPagination.pageSize"
            :callback="currentPageChange"
            @change="currentPageChange"
          />
        </div>
      </div>

      <!-- 2 -->
      <div v-else-if="activeTabKey === '2'" class="g-table">
        <a-table
          :columns="columns"
          :data-source="historyDataList"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          :loading="historyLoading"
          @change="handleHistoryTable"
        >
          <!-- 设备名称 -->
          <template slot="devName" slot-scope="text, record">
            <router-link
              :to="{
                name: 'DeviceDetail',
                params: { id: record.devId },
              }"
              v-if="AUTH_DEVICE_DETAIL"
            >
              <span>{{ text }}</span>
            </router-link>
            <span v-else>
              {{ text }}
            </span>
          </template>

          <!-- 时间 -->
          <template slot="startTime" slot-scope="text">
            {{ text | formatDate('yyyy-MM-dd HH:mm:ss') }}
          </template>

          <template slot="endTime" slot-scope="text">
            {{ text | formatDate('yyyy-MM-dd HH:mm:ss') }}
          </template>
        </a-table>
        <div class="pagination" style="margin-bottom:20px;">
          <Pagination
            :current.sync="historyPagination.current"
            :total="historyPagination.total"
            :pageSize.sync="historyPagination.pageSize"
            :callback="currentPageChange"
            @change="currentPageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SiteAlarmsCurrent, SiteAlarmsHistory } from '@/api/site';
import deviceAuth from '@/views/device/mixins/deviceAuth';
import siteAuth from '@/views/site/mixins/siteAuth';
import { trim } from '@/libs/utils';

export default {
  mixins: [deviceAuth, siteAuth],
  props: {
    // 站点信息
    siteData: {
      type: Object,
      default: () => ({}),
    },
    // 站点Id
    stationId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      trim,
      // 当前tab
      activeTabKey: '1',
      tabLists: [],

      // 展开
      searchExpand: true,
      searchExpandHistory: true,

      // 当前数据
      currentDataList: null,

      // 历史数据
      historyDataList: null,

      // 列表
      currentColumns: [
        {
          title: this.$t('com_table_index'),
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
          width: 60,
        },
        {
          title: this.$t('device_table_name'),
          dataIndex: 'devName',
          scopedSlots: { customRender: 'devName' },
        },

        {
          title: this.$t('com_table_warning_level'),
          dataIndex: 'lev',
          customRender: text => {
            const _text = Number(text);
            // <!-- 0:OA,1:MA;2:CA -->
            return _text === 0 ? 'OA' : _text === 1 ? 'MA' : _text === 2 ? 'CA' : '';
          },
        },

        {
          title: this.$t('com_table_alarm_name'),
          dataIndex: 'alarmName',
        },

        {
          title: this.$t('com_table_code'),
          dataIndex: 'code',
          customRender: text => {
            return text || '--';
          },
        },

        {
          title: this.$t('com_table_souce'),
          dataIndex: 'src',
        },

        {
          title: this.$t('logs_table_time_start'),
          dataIndex: 'startTm',
          scopedSlots: { customRender: 'startTime' },
          sorter: true,
        },
      ],

      // 列表
      columns: [
        {
          title: this.$t('com_table_index'),
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
          width: 60,
        },
        {
          title: this.$t('device_table_name'),
          dataIndex: 'devName',
          scopedSlots: { customRender: 'devName' },
        },

        {
          title: this.$t('com_table_warning_level'),
          dataIndex: 'lev',
          customRender: text => {
            const _text = Number(text);
            // <!-- 0:OA,1:MA;2:CA -->
            return _text === 0 ? 'OA' : _text === 1 ? 'MA' : _text === 2 ? 'CA' : '';
          },
        },

        {
          title: this.$t('com_table_alarm_name'),
          dataIndex: 'alarmName',
        },

        {
          title: this.$t('com_table_code'),
          dataIndex: 'code',
          customRender: text => {
            return text || '--';
          },
        },

        {
          title: this.$t('com_table_souce'),
          dataIndex: 'src',
        },

        {
          title: this.$t('logs_table_time_start'),
          dataIndex: 'startTm',
          scopedSlots: { customRender: 'startTime' },
          sorter: true,
        },

        {
          title: this.$t('logs_table_time_end'),
          dataIndex: 'endTm',
          scopedSlots: { customRender: 'endTime' },
          sorter: true,
        },
      ],

      // 默认最近3个月
      date: [],
      deviceName: '',

      faultCode: '',
      faultLevel: ['0', '1', '2'],

      // 默认最近6个月
      dateHistory: [],
      historyKeyword: '',
      alarmNameHistory: '',
      faultCodeHistory: '',
      faultLevelHistory: ['0', '1', '2'],

      currentPagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 20,
        // 记录总条数
        total: 0,

        // 排序
        orderType: 1,
        orderField: 2,
      },
      currentLoading: false,

      historyPagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 20,
        // 记录总条数
        total: 0,

        orderType: 1,
        orderField: 2,
      },
      historyLoading: false,
    };
  },
  computed: {
    hasNoContentAuth() {
      return !(this.AUTH_SITE_FAULT_CURRENT || this.AUTH_SITE_FAULT_HISTORY);
    },
  },

  created() {
    // tabs - 当前故障
    if (this.AUTH_SITE_FAULT_CURRENT) {
      this.tabLists.push({
        key: '1',
        name: this.$t('com_fault_current'),
      });
    }

    // tabs - 历史故障
    if (this.AUTH_SITE_FAULT_HISTORY) {
      this.tabLists.push({
        key: '2',
        name: this.$t('com_fault_history'),
      });
    }

    if (this.tabLists.length > 0) {
      this.activeTabKey = this.tabLists[0].key;
    }

    this.getData();
  },
  methods: {
    // 日期范围改变
    dateRangeChange(value) {
      this.date = value;

      // 重新获取数据
      this.getData();
    },

    // 日期范围改变
    dateRangeChangeHistory(value) {
      this.dateHistory = value;
      // 重新获取数据
      this.getData();
    },

    handleTabs(key) {
      this.activeTabKey = key;
      this.getData();
    },

    // 获取数据
    getData() {
      if (this.activeTabKey === '1') {
        this.getCurrentFaultList();
      } else {
        this.getHistoryFaultList();
      }
    },

    // 获取当前故障
    getCurrentFaultList(_params = {}) {
      // stationId:"站点主键",
      // levels:"告警等级，如果全部则不传，如果多个值则英文逗号区分，其值对应设备告警等级。// <!-- 0:OA,1:MA;2:CA -->",
      // startTime:"开始时间，必填, long类型",
      // endTime:"结束时间，必填",
      // pageNo:"页码",
      // pageSize:"每页数量",

      const params = {
        pageNo: this.currentPagination.current,
        pageSize: this.currentPagination.pageSize,
        stationId: this.stationId,
        levels: this.faultLevel ? this.faultLevel.join(',') : '',
        keyword: this.trim(this.deviceName) || undefined,
        startTime:
          this.date && this.date.length === 2 ? this.date[0].startOf('day').valueOf() : undefined,
        endTime:
          this.date && this.date.length === 2 ? this.date[1].endOf('day').valueOf() : undefined,
        // faultCode: this.faultCode,
        orderType: this.currentPagination.orderType,
        orderField: this.currentPagination.orderField,
        ...(_params || {}),
      };

      this.currentLoading = true;
      SiteAlarmsCurrent(params)
        .then(res => {
          if (res.code === 0) {
            this.currentDataList = res.data || [];

            this.currentPagination.total = res.totalCount || 0;
          }
        })
        .finally(() => {
          this.currentLoading = false;
        });
    },

    // 获取历史故障
    getHistoryFaultList(_params = {}) {
      // stationId:"站点主键",
      // levels:"告警等级，如果全部则不传，如果多个值则英文逗号区分，其值对应设备告警等级。// <!-- 0:OA,1:MA;2:CA -->",
      // keyword:"设备名",
      // startTime:"开始时间，必填, long类型",
      // endTime:"结束时间，必填",
      // pageNo:"页码",
      // pageSize:"每页数量",

      const params = {
        pageNo: this.historyPagination.current,
        pageSize: this.historyPagination.pageSize,
        stationId: this.stationId,
        levels: this.faultLevelHistory ? this.faultLevelHistory.join(',') : '',
        keyword: this.trim(this.historyKeyword) || undefined,
        startTime:
          this.dateHistory && this.dateHistory.length === 2
            ? this.dateHistory[0].startOf('day').valueOf()
            : undefined,
        endTime:
          this.dateHistory && this.dateHistory.length === 2
            ? this.dateHistory[1].endOf('day').valueOf()
            : undefined,
        // faultCode: this.faultCodeHistory,
        orderType: this.historyPagination.orderType,
        orderField: this.historyPagination.orderField,
        ...(_params || {}),
      };

      this.historyLoading = true;
      SiteAlarmsHistory(params)
        .then(res => {
          if (res.code === 0) {
            this.historyDataList = res.data || [];

            this.historyPagination.total = res.totalCount || 0;
          }
        })
        .finally(() => {
          this.historyLoading = false;
        });
    },

    // reset
    handleReset() {
      this.date = null;
      this.deviceName = '';
      this.faultCode = '';
      this.faultLevel = [];
      this.currentPagination.current = 1;
      this.historyPagination.current = 1;

      // 重新获取数据
      this.getData();
    },

    // reset
    handleResetHistory() {
      this.dateHistory = null;
      this.historyKeyword = '';
      this.alarmNameHistory = '';
      this.faultCodeHistory = '';
      this.faultLevelHistory = [];
      this.currentPagination.current = 1;
      this.historyPagination.current = 1;

      // 重新获取数据
      this.getData();
    },

    // 展开
    handleExpand() {
      this.searchExpand = !this.searchExpand;
    },

    // 展开
    handleExpandHistory() {
      this.searchExpandHistory = !this.searchExpandHistory;
    },

    // 分页
    currentPageChange(page) {
      if (this.activeTabKey === '1') {
        this.currentPagination.current = page;
      } else {
        this.historyPagination.current = page;
      }

      // 重新获取数据
      this.getData();
    },

    // 排序
    handleCurrentTable(pagination, filters, sorter) {
      const { field, order } = sorter;
      let orderField = 3;
      let orderType = 1;
      console.log('field', field);

      if (field === 'startTm') {
        orderField = 1;
      }
      orderType = order === 'ascend' ? 0 : 1;

      this.currentPagination.orderField = orderField;
      this.currentPagination.orderType = orderType;

      this.getCurrentFaultList({
        orderField,
        orderType,
      });
    },

    // 排序
    handleHistoryTable(pagination, filters, sorter) {
      const { field, order } = sorter;
      let orderField = 3;
      let orderType = 1;

      if (field === 'startTm') {
        orderField = 1;
      } else if (field === 'endTm') {
        orderField = 2;
      }
      orderType = order === 'ascend' ? 0 : 1;

      this.historyPagination.orderField = orderField;
      this.historyPagination.orderType = orderType;

      this.getHistoryFaultList({
        orderField,
        orderType,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.site-event-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  overflow-y: auto;
  .site-event-main-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
  }

  // 搜索
  .site-event-action {
    background: @g-layout-background;
    .site-event-action-content {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      width: 100%;
      background: #fff;
      padding: 24px;
      border-radius: 12px;
      margin-bottom: 16px;

      .site-event-tab {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        gap: 24px;
        margin-bottom: 16px;

        li {
          color: rgba(0, 0, 0, 0.88);
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          display: flex;

          &.active {
            color: @primary-color;
            font-weight: 600;
            position: relative;

            &::after {
              content: '';
              display: block;
              width: 100%;
              height: 2px;
              background: @primary-color;
              position: absolute;
              bottom: -4px;
              left: 0;
            }
          }
        }
      }

      .site-event-action-row1 {
        display: flex;
        justify-content: space-between;
        align-items: center;

        // 搜索排序
        ul.site-event-search {
          display: flex;
          margin: 0;
          padding: 0;
          list-style: none;
          align-items: center;
          justify-content: flex-start;
          gap: 12px;
          flex-wrap: wrap;
          li {
            display: flex;
            align-items: center;
            // width: 296px;
            gap: 12px;
            &:last-child {
              width: auto;
            }

            .site-event-search-keyword {
              min-width: 380px;
            }
          }
        }

        // 排序
        .site-event-btn {
          display: flex;
          align-items: center;

          button {
            margin-left: 12px;
          }
        }
      }

      .site-event-action-row2 {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 24px 0 0 0;
        span {
          color: rgba(0, 0, 0, 0.88);
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          margin-right: 16px;
          white-space: nowrap;
        }

        .ant-checkbox-group {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
          flex-wrap: wrap;
          .ant-checkbox-wrapper {
            margin: 0;
          }

          .ant-checkbox {
            color: rgba(0, 0, 0, 0.88);
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
          }
        }
      }
    }
  }

  // 内容
  .site-event-content {
    background: #fff;
    box-shadow: 0 -12px 0 0 @g-layout-background;
    border-radius: 12px;
    flex: 1;
    padding: 24px;

    // 卡片模式
    .site-event-content-card {
      display: flex;
      grid-gap: 16px;
      padding-top: 16px;
      width: 100%;
      flex-wrap: wrap;

      li {
        width: calc(20% - 16px);
        height: 337px;
        border-radius: 6px;
        border: 1px solid #eee;

        .card-title {
          line-height: 24px;
          color: rgba(0, 0, 0, 0.88);
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 8px;
          padding: 24px 24px 0 24px;

          a {
            color: rgba(0, 0, 0, 0.88);
            text-decoration: none;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            display: block;
            width: 100%;

            &:hover {
              color: @primary-color;
            }
          }
        }

        .card-content {
          padding: 0 24px 16px 24px;
          .card-content-time {
            display: flex;
            justify-content: space-between;
            gap: 8px;
            margin: 0;

            dd {
              color: rgba(0, 0, 0, 0.45);
              font-size: 14px;
              height: 80px;
              width: 50%;
              border-radius: 12px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              strong {
                font-size: 36px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
              }
              span {
                color: #18181a;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }

              &:first-child {
                background: #f6ffed;
                strong {
                  color: #52c41a;
                }
              }

              &:last-child {
                background: #fffbe6;
                strong {
                  color: #faad14;
                }
              }
            }
          }
          p {
            padding: 0;
            margin: 0 0 8px 0;
            color: #18181a;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            label {
              white-space: nowrap;
            }
            span {
              word-wrap: break-word;
              word-break: break-all;
            }
          }
        }

        .card-action {
          padding: 8px 0;
          border-top: #eee solid 1px;
          dl {
            display: flex;
            justify-content: space-between;

            dd {
              cursor: pointer;
              font-size: 16px;
              transition: all 0.3s;
              border-right: solid 1px rgba(0, 0, 0, 0.06);
              flex: 1;
              height: 38px;
              display: flex;
              align-items: center;
              justify-content: center;

              &:last-child {
                border-right: none;
              }

              a {
                display: flex;
                width: 100%;
                align-items: center;
                justify-content: center;
                color: #000;
                cursor: pointer;
                height: 100%;

                svg {
                  width: 24px;
                  height: 24px;
                  opacity: 0.45;
                }

                &:hover {
                  color: @primary-color;
                  svg.icon {
                    color: @primary-color;
                  }
                }
              }
            }
          }
        }

        &:hover {
          box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
        }
      }
    }

    // 列表模式
    .site-event-content-list {
      padding-top: 16px;

      .site-event-action {
        display: flex;
        background: none;
        padding: 0;
        margin: 0;
        height: auto;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>
